module.exports = __webpack_public_path__ + "img/content.1b47485d.png";